export interface DrfErrorData {
  detail?: string;
  non_field_errors?: string[];
  [key: string]: unknown;
}

export interface ApiErrorResponse {
  response?: {
    data?: DrfErrorData | { message?: string };
  };
  message?: string;
}

export function isDrfErrorData(data: unknown): data is DrfErrorData {
  return (
    typeof data === 'object' &&
    data !== null &&
    (typeof (data as DrfErrorData).detail === 'string' ||
      Array.isArray((data as DrfErrorData).non_field_errors) ||
      Object.keys(data).some((key) => key !== 'detail' && key !== 'non_field_errors'))
  );
}

export function isMessageObject(data: unknown): data is { message: string } {
  return typeof data === 'object' && data !== null && typeof (data as { message: string }).message === 'string';
}

export function getErrorMessage(error: unknown): string {
  let errorMessage = 'An unknown error occurred.';
  const apiError = error as ApiErrorResponse;

  if (apiError.response?.data) {
    const errorData = apiError.response.data;
    if (isDrfErrorData(errorData)) {
      if (errorData.detail) {
        errorMessage = errorData.detail;
      } else if (errorData.non_field_errors) {
        errorMessage = errorData.non_field_errors.join(' ');
      } else {
        const fieldErrors = Object.entries(errorData)
          .filter(([key]) => key !== 'detail' && key !== 'non_field_errors')
          .map(([key, value]) => {
            const message = Array.isArray(value) ? value.join(', ') : String(value);
            return `${key}: ${message}`;
          })
          .join('; ');
        if (fieldErrors) errorMessage = fieldErrors;
      }
    } else if (isMessageObject(errorData)) {
      errorMessage = errorData.message;
    }
  } else if (apiError.message) {
    errorMessage = apiError.message;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return errorMessage;
}
